/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-cycle */
import React, { FC, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { Formik, FormikProps } from 'formik';
import DOMPurify from 'isomorphic-dompurify';
import { useGoogleLogin } from '@react-oauth/google';
import { useRouter } from 'next/router';
import { AUTH_ERRORS } from 'Constants/ErrorMessages';
import RichText from '../../RichText';
// import ButtonGroup from '@mui/material/ButtonGroup';
import FinalConfirmations, { withLink } from './Sections/FinalConfirmations';
import { getFieldError } from '../../FormFields/Utils';
import { ROUTES, STORAGE_UTM_PARAMS } from '../../../Constants/variables';
import { RadioOptions } from '../../FormFields/RadioButton';
import SelectRole from './Sections/SelectRole';
import { SignUpFormData, TRole } from '../../../models/auth/@types';

import AuthContext from '../../../AppContext/AuthProvider';
import { analytics } from '../../../utils/Analytics';
import AuthModel from '../../../models/auth';
import AuthThankYou from '../AuthThankYou';
import Button from '../../Button';
import Email from './Sections/Email';
import MentorCode from './Sections/MentorCode';
import { PageLoader } from '../../../HOC/Page/WithPage';
import Password from './Sections/Password';
import PersonalInfo from './Sections/PersonalInfo';
import SectionWrapper from '../../SectionWrapper';
import { TAuthMessages } from '../@types';
import Typo from '../../Typo';
import emailIcon from '../../../../public/static/images/email-icon.svg';
import googleLogo from '../../../../public/static/images/google-logo.svg';
import styles from './signUpForm.module.sass';
import { useIsMobileViewport } from '../../../hooks/useIsMobileViewport';
import useLoginActions from '../LogInForm/useLoginActions';
import useSignUpActions from './useSignUpActions';
import ImageComponent from '../../Image';
import { ValidationSchema, ValidationSchemaSSO } from './schema';
import HelperText from '../../FormFields/HelperText';
import contentfulClient from '../../../models/Contentful';
import SelectField, { SelectFieldOption } from '../../FormFields/SelectField';

export const NAF_OPTIONS: RadioOptions[] = [
  {
    name: 'Yes',
    value: '1',
    id: 'naf-true',
  },
  { name: 'No', value: '0', id: 'naf-false' },
  { name: "I don't know", value: '2', id: 'naf-unknown' },
];

interface ISignupForm {
  messages: TAuthMessages;
  mentor?: boolean;
}

export const SignUpForm: FC<ISignupForm> = ({ messages }) => {
  const { isMobile } = useIsMobileViewport();
  const { handleSignUp, state } = useSignUpActions();
  const thankYouMessage = messages['Signup - Thank you'];

  return (
    <Formik<Partial<SignUpFormData>>
      onSubmit={(val, helpers) => {
        handleSignUp.run({ values: val, formikHelpers: helpers });
      }}
      validationSchema={ValidationSchema}
      initialValues={{}}
      enableReinitialize
    >
      {(formikProps: FormikProps<Partial<SignUpFormData>>) => {
        return (
          <form onSubmit={formikProps.handleSubmit} id="sign_up_form_deprecated">
            <SectionWrapper
              hasBodyMargin={!isMobile}
              classes={styles.rootContainer}
              childClasses={clsx(styles.rootChildContainer, {
                [styles.thanksRootChildContainer]: state === 'thank-you',
              })}
            >
              <Typo h1 classes={styles.heading}>
                Sign Up Now
              </Typo>
              {/* <div
                className={
                  state === "thank-you"
                    ? styles.thanksSubHead
                    : styles.subheading
                }
              >
                <Typo medium>
                  {formikProps.values.role === TRole.MENTOR
                    ? "Let's do this! Register today (it's free!) and track your progress completing or mentoring any KnoPro Challenge or Skillbuilder you’re involved with. (Plus, we’ll never share your info outside of KnoPro. Promise.)"
                    : "Let's do this! Register today (it's free!) for full access to the KnoPro experience. (Plus, we'll never share your info outside of KnoPro. Promise."}
                </Typo>
              </div> */}
              {state === 'sign-up-form' && (
                <>
                  <Typo h2 classes="mb-3" />
                  <SelectRole valueKey="role" formikProps={formikProps} messages={messages} />
                  {formikProps?.values?.role && (
                    <PersonalInfo
                      firstNameKey="first_name"
                      lastNameKey="last_name"
                      schoolNameKey="organization"
                      industryNameKey="industry"
                      cityNameKey="city"
                      stateNameKey="state"
                      googleMode={false}
                      formikProps={formikProps}
                    />
                  )}
                </>
              )}
              {state === 'thank-you' && <AuthThankYou {...thankYouMessage} />}
            </SectionWrapper>
            {formikProps?.values?.role && state === 'sign-up-form' && (
              <SectionWrapper
                hasBodyMargin={!isMobile}
                classes={styles.secondContainer}
                childClasses={styles.secondChildContainer}
              >
                <Email valueKey="email" formikProps={formikProps} messages={messages} />

                <Password
                  passwordKey="password"
                  confirmPasswordKey="confirmPassword"
                  formikProps={formikProps}
                />
                {formikProps.values.role === TRole.MENTOR && (
                  <MentorCode mentorCodeKey="mentorCode" formikProps={formikProps} />
                )}
                <FinalConfirmations
                  formikProps={formikProps}
                  privacyPolicyKey="is_policy_accepted"
                  roleConfirmationKey="is_role_accepted"
                />

                <Button
                  classes={`mb-5 ${handleSignUp.status === 'PROCESSING' && 'is-loading'}`}
                  disabled={handleSignUp.status === 'PROCESSING'}
                  theme="Filled - Lime Green Gradient"
                  type="submit"
                >
                  Sign Up
                </Button>
                <div>
                  <Typo normal>Already have an account? {withLink('Log in', 'log-in', true)}</Typo>
                </div>
              </SectionWrapper>
            )}
          </form>
        );
      }}
    </Formik>
  );
};

export const SignUpFormSSO: FC<ISignupForm> = ({ messages, mentor = false }) => {
  const { isMobile } = useIsMobileViewport();
  const { handleSignUp, state } = useSignUpActions();
  const { handleLogin } = useLoginActions();
  const [educatorSpecial, setEducatorSpecial] = useState(false);
  const [googleMode, setGoogleMode] = useState<boolean>(false);
  const [emailMode, setEmailMode] = useState<boolean>(false);
  const [role, setRole] = useState<string | null>(mentor ? TRole.MENTOR : TRole.STUDENT);
  const [personalInformation, setPersonalInformation] = useState<boolean>(false);
  const [googleObject, setGoogleObject] = useState<any>({});
  const [beforeGoogleRequest, setBeforeGoogleRequest] = useState<boolean>(true);
  const { ssoLoggedIn, redirectLoad, setAuthState } = useContext(AuthContext);
  const [pageLoaded, setPageLoaded] = useState<boolean>(false);
  const [codeState, setCodeState] = useState<string | null>(null);
  const [towardTwo, setTowardTwo] = useState<string | null>(null);
  const [leftParagraphStudent, setLeftParagraphStudent] = useState<any>(null);
  const [leftParagraphEducator, setLeftParagraphEducator] = useState<any>(null);
  const [leftTitleStudent, setLeftTitleStudent] = useState<string | null>(null);
  const [leftTitleEducator, setLeftTitleEducator] = useState<string | null>(null);
  const [leftImageStudent, setLeftImageStudent] = useState<string>('');
  const [leftImageEducator, setLeftImageEducator] = useState<string>('');
  const [requestError, setRequestError] = useState<string | undefined>();
  const [requestSuccess, setRequestSuccess] = useState<string | undefined>();
  const [studentAgeVerified, setStudentAgeVerified] = useState<boolean>(false);
  const [ageError, setAgeError] = useState<boolean>(false);
  const [ageErrorText, setAgeErrorText] = useState<string>('Please provide your birth date');
  const [ageYear, setAgeYear] = useState<number | undefined>();
  const [ageMonth, setAgeMonth] = useState<number | undefined>();
  const [ageDay, setAgeDay] = useState<number | undefined>();
  const [leapYear, setLeapYear] = useState<boolean>(false);
  const [loginLink, setLoginLink] = useState<string>('log-in');
  const SIGN_UP_LINK = `${ROUTES.SIGNUP}/`;
  const router = useRouter();
  const pageLoading = !!(
    (ssoLoggedIn && ssoLoggedIn === 'true') ||
    (redirectLoad && redirectLoad === 'true') ||
    !pageLoaded
  );
  // pulls the "sign up page left column" page from Contentful, iterates through the response
  // to get the necessary information
  const mediaCards = async () => {
    const response: any = await contentfulClient.getEntries({
      content_type: 'pages',
      limit: 1,
      'fields.slug': 'sign-up-page-left-column',
    });
    response.items[0].fields.widget.map((widget: any, key: number) => {
      if (key === 0) {
        setLeftTitleStudent(widget.fields.title);
        setLeftParagraphStudent(
          <RichText classes={styles.textBody} document={widget.fields.description} />,
        );
        if (widget.fields.media) {
          const leftImage = `https:${widget.fields.media.fields.file.url}`;
          setLeftImageStudent(leftImage);
        }
      } else if (key === 1) {
        setLeftTitleEducator(widget.fields.title);
        setLeftParagraphEducator(
          <RichText classes={styles.textBody} document={widget.fields.description} />,
        );
        if (widget.fields.media) {
          const leftImage = `https:${widget.fields.media.fields.file.url}`;
          setLeftImageEducator(leftImage);
        }
      }
      return null;
    });
  };

  // Remove loading states, so loading spinner will not block UI
  const removeLoading = useCallback(() => {
    setAuthState('sso', null);
    setAuthState('redirected', null);
    setAuthState('redirectLoad', null);
  }, [setAuthState]);
  // Remove URL parameters for easy refresh, lint requires conditional here.
  const removeParameters = useCallback(
    (urlParams: any) => {
      urlParams.delete('code');
      urlParams.delete('scope');
      urlParams.delete('authuser');
      urlParams.delete('prompt');
      const urlParamsString = urlParams.toString();
      const url = urlParamsString.length > 0 ? `${SIGN_UP_LINK}?${urlParamsString}` : SIGN_UP_LINK;
      router.replace(url);
    },
    [SIGN_UP_LINK, router],
  );
  // Handles sending SSO data to backend, and then either continuing sign up or,
  // if the user already has an account, logging in.
  useEffect(() => {
    if (beforeGoogleRequest) {
      mediaCards();
      setBeforeGoogleRequest(false);
      const queryParams = new URLSearchParams(window.location.search);
      const queryRole = queryParams.get('role');
      const code = queryParams.get('code');
      let loginLinkUseEffect = 'log-in';
      if (queryParams.get('partner') === 'true' || localStorage.getItem('partner') === 'true') {
        setLoginLink('log-in?partner=true');
        loginLinkUseEffect = 'log-in?partner=true';
      }
      setCodeState(code);
      // If we're on the mentor sign up, role will always be mentor
      const sessionRole = mentor ? TRole.MENTOR : localStorage.getItem('role');
      if (queryRole === 'educator') {
        setRole(TRole.TEACHER);
        setEducatorSpecial(true);
      } else {
        setRole(sessionRole !== null ? sessionRole : role);
      }
      if (sessionRole && sessionRole !== '' && code && !googleMode) {
        setAuthState('redirectLoad', 'true');
        setAuthState('redirected', 'true');
        AuthModel.getGoogleUser(code, 'signup')
          .then(jwt => {
            // If google returns data for user and email DOES NOT exist, move to second screen
            if (jwt.data && !jwt.data.condition) {
              setGoogleObject(jwt.data);
              setGoogleMode(true);
              setPersonalInformation(true);
              setAuthState('redirectLoad', null);
              // DEPRECATED: If google returns data for user and email DOES exist, we log them in.
            } else if (jwt.responseCode && !jwt.data.condition) {
              setAuthState('sso', 'true');
              handleLogin.run({ values: null, previousLogin: true });
              setAuthState('redirectLoad', null);
              // If google returns data for user and email DOES exist, we throw an error and stop loading.
            } else if (jwt.data.code) {
              const { code } = jwt.data;
              removeLoading();
              // User is signing up, but is already registered, so is asked to log in.
              if (code === 422) {
                const purifiedError = DOMPurify.sanitize(`
              Please <a class=${styles.errorLink} href="/${loginLinkUseEffect}">Log In</a>.`);
                setRequestSuccess(purifiedError);
                // Every other error
              } else {
                const purifiedError = DOMPurify.sanitize(`${jwt.data.message}.`);
                setRequestError(purifiedError);
              }
            }
            removeParameters(queryParams);
            setAuthState('redirectLoad', null);
          })
          .catch(e => {
            removeLoading();
            removeParameters(queryParams);
            const purifiedError = DOMPurify.sanitize(`${e.response?.data?.error}`);
            setRequestError(purifiedError);
          });
      } else if (sessionRole && !towardTwo) {
        removeLoading();
      } else if (!towardTwo) {
        localStorage.removeItem('role');
        setAuthState('redirected', null);
        removeParameters(queryParams);
      }
    }
  }, [
    googleMode,
    handleLogin,
    beforeGoogleRequest,
    router,
    setAuthState,
    removeLoading,
    removeParameters,
    SIGN_UP_LINK,
    towardTwo,
    mentor,
    role,
    loginLink,
  ]);
  // First loading failsafe
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (localStorage.getItem('partner') === 'true') {
      window.history.replaceState(null, '', '?partner=true');
      localStorage.removeItem('partner');
    }

    if (queryParams.get('partner') === 'true' || localStorage.getItem('partner') === 'true') {
      setLoginLink('log-in?partner=true');
      localStorage.setItem('partner', 'true');
    }
    const localRole = localStorage.getItem('role');
    // Fix for infinite loading screen. If no query params, then stop all loading
    if (
      !emailMode &&
      ((!codeState && !towardTwo && queryParams.size === 0 && !redirectLoad) ||
        (redirectLoad && !towardTwo && !codeState && localRole))
    ) {
      removeLoading();
    }
    setPageLoaded(true);
  }, [codeState, emailMode, redirectLoad, removeLoading, towardTwo]);
  // Second loading failsafe
  useEffect(() => {
    const localRedirected = localStorage.getItem('redirected');
    if (localRedirected) {
      setAuthState('sso', localStorage.getItem('sso'));
      setAuthState('redirected', localRedirected);
      setAuthState('redirectLoad', localStorage.getItem('redirectLoad'));
      setRole(localStorage.getItem('role'));
    }
    if ((ssoLoggedIn === 'true' || redirectLoad === 'true') && !emailMode) {
      const loadingDestroyer = () => {
        if (
          (localStorage.getItem('sso') === 'true' || localStorage.getItem('redirectLoad')) &&
          !requestError
        ) {
          removeLoading();
          setRequestError('Your request appears to be taking awhile. Please try again later.');
        }
      };
      setTimeout(() => {
        loadingDestroyer();
      }, 30000);
    }
  }, [ssoLoggedIn, redirectLoad, setAuthState, requestError, removeLoading, emailMode]);
  // Experimenting with removing params on refresh. This is not ready.
  // useEffect(() => {
  //   window.addEventListener("beforeunload", (e) => {
  //     e.preventDefault();
  //     removeParameters();
  //     localStorage.removeItem("role");
  //     router.reload();
  //   });
  // });
  useEffect(() => {
    // if (googleMode || emailMode) {
    router.beforePopState(() => {
      const currentPath = router.asPath;
      if (googleMode || emailMode) {
        if (
          // eslint-disable-next-line no-restricted-globals,no-alert
          confirm(
            'If you go back before submitting, you may lose your progress. Are you sure you want go back?',
          )
        ) {
          if (googleMode || emailMode) {
            if (personalInformation && emailMode) {
              setAuthState('redirected', null);
              setPersonalInformation(false);
            } else if (!personalInformation && emailMode) {
              setEmailMode(false);
            }
            if (personalInformation && googleMode) {
              setAuthState('redirected', null);
              setPersonalInformation(false);
              setGoogleMode(false);
            }
          }
          window.history.pushState(null, '', currentPath);
          return false;
        }
      }
      return true;
    });
    // }
  }, [emailMode, googleMode, personalInformation, router, setAuthState]);
  // Request to Google for auth code
  const googleRequest = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
    redirect_uri: process.env.NEXT_PUBLIC_GOOGLE_SIGN_UP,
  });

  const formInitialValues = useMemo(() => {
    let values;
    if (googleMode) {
      values = {
        email: googleObject.email,
        sign_up_type: 'sso',
        sso_type: 'google',
        sso_id: googleObject.id,
      };
    } else {
      values = {
        sign_up_type: 'email',
      };
    }
    return {
      role: (role as TRole) || '',
      ...values,
    };
  }, [googleMode, role, googleObject.email, googleObject.id]);
  const leftSide = (role: string | undefined) => {
    return (
      <div className={styles.leftSide}>
        {(role === '' || role === TRole.STUDENT) && (
          <>
            <Typo h2 classes={styles.greenHeader}>
              {leftTitleStudent}
            </Typo>
            <br />
            <Typo h3 classes={styles.textBody}>
              {leftParagraphStudent}
            </Typo>
            {leftImageStudent !== '' && (
              <ImageComponent image={leftImageStudent} classes={styles.leftSideImage} />
            )}
          </>
        )}
        {role === TRole.TEACHER && (
          <>
            <Typo h2 classes={styles.greenHeader}>
              {leftTitleEducator}
            </Typo>
            <br />
            <Typo h3 classes={styles.textBody}>
              {leftParagraphEducator}
            </Typo>
            {leftImageEducator !== '' && (
              <ImageComponent image={leftImageEducator} classes={styles.leftSideImage} />
            )}
          </>
        )}
      </div>
    );
  };
  const month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ].map(
    (month, index) =>
      ({
        id: index,
        name: month,
        value: index,
      }) as SelectFieldOption,
  );
  const dayCountCalculator = () => {
    if (ageMonth) {
      if ([3, 5, 8, 10].includes(ageMonth)) {
        return 30;
      }
      if (ageMonth === 1) {
        return leapYear ? 29 : 28;
      }
    }
    return 31;
  };
  const dayCount = dayCountCalculator();
  const day = Array.from(
    new Array(dayCount),
    (v, i) =>
      ({
        id: i + 1,
        name: i + 1,
        value: i + 1,
      }) as SelectFieldOption,
  );
  const currentYear = new Date().getFullYear();
  const yearDifference = currentYear - 1905;
  const year: SelectFieldOption[] = Array.from(
    new Array(yearDifference),
    (v, i) =>
      ({
        id: currentYear - i,
        name: currentYear - i,
        value: currentYear - i,
      }) as SelectFieldOption,
  );
  const handleDateChange = (e: any, dateType: string) => {
    let { value } = e.target;
    // selecting the default value results in an empty string, which messes up
    // the Date converter in ageCalculator(), so this changes it to undefined, which
    // properly triggers the correct validation error.
    if (value === '') {
      value = undefined;
    }
    switch (dateType) {
      case 'year':
        setAgeYear(value);
        // check for leap year
        setLeapYear(value % 4 === 0);
        break;
      case 'month':
        setAgeMonth(parseInt(value, 10));
        break;
      case 'day':
        setAgeDay(value);
        break;
      default:
        break;
    }
    if (dateType === 'year') {
      setAgeYear(value);
      // check for leap year
      setLeapYear(value % 4 === 0);
    }
    if (dateType === 'month') {
      setAgeMonth(parseInt(value, 10));
    }
    if (dateType === 'day') {
      setAgeDay(value);
    }
  };
  const ageCalculator = (month: number, day: number, year: number) => {
    const birthDate = new Date(year, month, day);
    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = currentDate.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
      age -= 1;
    }
    return age;
  };

  const getReferralSource = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    if (utmSource) return utmSource;

    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer);
        return referrerUrl.hostname;
      } catch (e) {
        // Invalid URL
      }
    }

    return 'signup_form';
  };

  return (
    <Formik<Partial<SignUpFormData>>
      onSubmit={(val, helpers) => {
        // Start loading for sign up/login
        if (typeof val.city === 'string' && val.city.length === 0) {
          helpers.setFieldError('city', AUTH_ERRORS.CITY_REQUIRED);
          return;
        }
        setAuthState('sso', 'true');
        localStorage.removeItem('role');
        let utmParams;
        try {
          utmParams = JSON.parse(localStorage.getItem(STORAGE_UTM_PARAMS) || '{}');
          localStorage.removeItem(STORAGE_UTM_PARAMS);
        } catch (e) {
          utmParams = {};
        }
        handleSignUp.run({
          values: { ...val, ...utmParams },
          formikHelpers: helpers,
        });
      }}
      validationSchema={googleMode ? ValidationSchemaSSO : ValidationSchema}
      validateOnBlur
      validateOnChange={false}
      initialValues={formInitialValues}
      enableReinitialize
    >
      {(formikProps: FormikProps<Partial<SignUpFormData>>) => {
        const selectedRole = role || formikProps?.values?.role;
        const nafAcademyError = getFieldError('naf_academy', formikProps);
        return (
          <form onSubmit={formikProps.handleSubmit} id="sign_up_form">
            <div className={styles.signUpForm}>
              {pageLoading && <PageLoader />}
              <SectionWrapper
                hasBodyMargin={!isMobile}
                classes={pageLoading ? styles.hidden : styles.rootContainer}
                childClasses={clsx(styles.rootChildContainer, {
                  [styles.thanksRootChildContainer]: state === 'thank-you',
                })}
              >
                {state === 'sign-up-form' && !googleMode && !emailMode && !personalInformation && (
                  <SectionWrapper
                    hasBodyMargin={!isMobile}
                    classes={styles.rootContainer}
                    childClasses={clsx(styles.rootChildContainer)}
                  >
                    {leftSide(selectedRole)}
                    <div className={styles.rightSide}>
                      {(role !== TRole.STUDENT ||
                        (role === TRole.STUDENT && !studentAgeVerified)) &&
                        !educatorSpecial && (
                          <SelectRole
                            valueKey="role"
                            formikProps={formikProps}
                            messages={messages}
                            role={role || formikProps?.values?.role || ''}
                            setRole={setRole}
                            requestError={requestError}
                            requestSuccess={requestSuccess}
                          />
                        )}
                      {!studentAgeVerified &&
                        (formikProps?.values?.role === TRole.STUDENT || role === TRole.STUDENT) && (
                          <>
                            <Typo
                              h3
                              bold
                              classes={clsx(styles.header, styles.ageVerificationHeader)}
                            >
                              What is your birth date?
                            </Typo>
                            <div className={styles.ageVerificationBox}>
                              <SelectField
                                valueKey="ageMonth"
                                options={month}
                                emptyOption="Month"
                                otherProps={{
                                  onChange: e => handleDateChange(e, 'month'),
                                }}
                                rootClassName={styles.ageSelect}
                              />
                              <SelectField
                                valueKey="ageDay"
                                options={day}
                                emptyOption="Day"
                                otherProps={{
                                  onChange: e => handleDateChange(e, 'day'),
                                }}
                                rootClassName={styles.ageSelect}
                              />
                              <SelectField
                                valueKey="ageYear"
                                options={year}
                                emptyOption="Year"
                                otherProps={{
                                  onChange: e => handleDateChange(e, 'year'),
                                }}
                                rootClassName={styles.ageSelect}
                              />
                            </div>
                            {ageError && <div className={styles.ageError}>{ageErrorText}</div>}
                            <Button
                              classes={clsx('mb-5', styles.ageButton)}
                              type="button"
                              theme="Filled - Lime Green Gradient"
                              onClick={() => {
                                if (
                                  typeof ageMonth === 'undefined' ||
                                  typeof ageDay === 'undefined' ||
                                  typeof ageYear === 'undefined'
                                ) {
                                  setAgeError(true);
                                  setAgeErrorText('Please provide your birth date');
                                  return;
                                }
                                const age = ageCalculator(ageMonth, ageDay, ageYear);
                                if (Number.isNaN(age)) {
                                  setAgeError(true);
                                  setAgeErrorText('Please provide your birth date');
                                  return;
                                }
                                if (age >= 13) {
                                  setAgeError(false);
                                  setStudentAgeVerified(true);
                                  analytics.trackEvent('Sign Up Started', {
                                    user_role: role,
                                    device_type: navigator.userAgent,
                                    referral_source: getReferralSource(),
                                  });
                                } else {
                                  setAgeErrorText(
                                    'You must be at least 13 years old to create a KnoPro account',
                                  );
                                  setAgeError(true);
                                }
                              }}
                            >
                              Continue
                            </Button>
                          </>
                        )}
                      {/* If a role has been selected and Google SSO and Email have not been selected */}
                      {(formikProps?.values?.role || role) &&
                        (role !== TRole.STUDENT ||
                          (role === TRole.STUDENT && studentAgeVerified)) &&
                        state === 'sign-up-form' &&
                        !googleMode &&
                        !emailMode &&
                        !personalInformation && (
                          <SectionWrapper classes={styles.buttonHolder}>
                            <Button
                              onClick={() => {
                                setTowardTwo('true');
                                // setAuthState("redirectLoad", "true");
                                // setAuthState("redirected", "true");
                                localStorage.setItem(
                                  'role',
                                  formikProps.values.role ? formikProps.values.role : '',
                                );
                                setBeforeGoogleRequest(true);
                                setRequestSuccess(undefined);
                                setRequestError(undefined);
                                localStorage.setItem('partner', 'true');
                                googleRequest();
                              }}
                              classes={styles.authButton}
                            >
                              <ImageComponent
                                image={googleLogo}
                                width={30}
                                height={30}
                                classes={styles.googleLogo}
                              />
                              Sign up with Google
                            </Button>
                            <br />
                            <Button
                              onClick={() => {
                                if (mentor) {
                                  localStorage.setItem('role', TRole.MENTOR);
                                }
                                setRequestSuccess(undefined);
                                setRequestError(undefined);
                                setEmailMode(true);
                              }}
                              classes={styles.authButton}
                            >
                              <ImageComponent
                                image={emailIcon}
                                width={30}
                                height={30}
                                classes={styles.googleLogo}
                              />
                              Sign up with Email
                            </Button>
                          </SectionWrapper>
                        )}
                      <div>
                        <Typo normal>
                          Already have an account? {withLink('Log in', loginLink, true)}
                        </Typo>
                      </div>
                    </div>
                  </SectionWrapper>
                )}
                {emailMode && !personalInformation && (
                  <SectionWrapper
                    hasBodyMargin={!isMobile}
                    classes={styles.secondContainer}
                    childClasses={styles.secondChildContainer}
                  >
                    {leftSide(selectedRole)}
                    <div className={styles.rightSide}>
                      <Email valueKey="email" formikProps={formikProps} messages={messages} />
                      <Password
                        passwordKey="password"
                        confirmPasswordKey="confirmPassword"
                        formikProps={formikProps}
                      />
                      <Button
                        classes="mb-5"
                        type="button"
                        theme="Filled - Lime Green Gradient"
                        onClick={() => {
                          formikProps.setFieldTouched('email', true);
                          formikProps.setFieldTouched('password', true);
                          formikProps.setFieldTouched('confirmPassword', true);
                          if (
                            !formikProps.errors.email &&
                            !formikProps.errors.password &&
                            !formikProps.errors.confirmPassword
                          ) {
                            setRequestSuccess(undefined);
                            setRequestError(undefined);
                            setPersonalInformation(true);
                          }
                        }}
                      >
                        Continue
                      </Button>
                      <div>
                        <Typo normal>
                          Already have an account? {withLink('Log in', loginLink, true)}
                        </Typo>
                      </div>
                    </div>
                  </SectionWrapper>
                )}
                {(formikProps?.values?.role || role) &&
                  (googleMode || emailMode) &&
                  personalInformation && (
                    <SectionWrapper
                      hasBodyMargin={!isMobile}
                      classes={styles.rootContainer}
                      childClasses={clsx(styles.rootChildContainer)}
                    >
                      {leftSide(selectedRole)}
                      <div className={styles.rightSide}>
                        <PersonalInfo
                          firstNameKey="first_name"
                          lastNameKey="last_name"
                          schoolNameKey="organization"
                          industryNameKey="industry"
                          cityNameKey="city"
                          stateNameKey="state"
                          googleMode={googleMode}
                          formikProps={formikProps}
                        />
                        {/* Naf Academy radio buttons */}
                        {formikProps.values.role !== TRole.MENTOR && (
                          <div className={styles.nafHolder}>
                            <Typo normal bold classes={styles.fieldLabel}>
                              Are you currently in a NAF academy?
                            </Typo>
                            {/** loop through NAF_OPTIONS, generating a button for each * */}
                            {NAF_OPTIONS.map(nafOption => {
                              return (
                                <Button
                                  key={nafOption.id}
                                  className={clsx(
                                    styles.pillButton,
                                    formikProps?.values?.naf_academy === nafOption.value &&
                                      styles.pillButtonSelected,
                                    nafAcademyError && styles.pillButtonError,
                                  )}
                                  onClick={() => {
                                    formikProps.setFieldValue('naf_academy', nafOption.value);
                                  }}
                                >
                                  {nafOption.name}
                                </Button>
                              );
                            })}
                            <HelperText className="is-block" error={!!nafAcademyError}>
                              {nafAcademyError}
                            </HelperText>
                          </div>
                        )}
                        {formikProps.values.role === TRole.MENTOR && (
                          <MentorCode mentorCodeKey="mentorCode" formikProps={formikProps} />
                        )}
                        <FinalConfirmations
                          formikProps={formikProps}
                          privacyPolicyKey="is_policy_accepted"
                          roleConfirmationKey="is_role_accepted"
                        />

                        <div className={styles.inputBoxDisplay}>
                          <input name="email" type="email" value={formikProps.values.email} />
                          <input
                            type="text"
                            name="sign_up_type"
                            value={formikProps.values.sign_up_type}
                          />
                          <input type="text" name="sso_type" value={formikProps.values.sso_type} />
                          <input type="text" name="sso_id" value={formikProps.values.sso_id} />
                          <input type="text" name="role" value={formikProps.values.role} />
                        </div>

                        <Button
                          classes={`mb-5 ${handleSignUp.status === 'PROCESSING' && 'is-loading'}`}
                          disabled={handleSignUp.status === 'PROCESSING'}
                          theme="Filled - Lime Green Gradient"
                          type="submit"
                        >
                          Sign Up
                        </Button>
                      </div>
                    </SectionWrapper>
                  )}
              </SectionWrapper>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
